
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import InputSelectForNotification from "../../shared/input/new/InputSelectForNotification"
import { getPhoneNumberForNotification } from "../../../features/admin4/admin4Slice"
import { IoCloseCircleOutline } from "react-icons/io5";
import { shareYukBulItems } from "../../../features/admin5/admin5Slice"
import InputTextarea from "../../shared/input/new/InputTextarea"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 60px;
            margin: 20px 0;
            width: 1100px;
            gap: 30px;
            height: 400px;
            font-weight: var(--font-weight-md);
            font-size: var(--font-size-sm);

            .input-container{
                display: flex;
                gap: 20px;
            }

            .phone-number-list{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 20px;
            max-height: 285px;
            overflow: auto;
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            border-radius: 10px;
            padding: 10px;

            &::-webkit-scrollbar {
                width: 0;
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: ${({theme})=> theme.scrollThumbColor};
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }
            
            .phone-number-item{
                padding: 8px;
                border: 1px solid var(--color-main);
                border-radius: 10px;
                color: var(--color-main);
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                display: flex;
                align-items: center;
                gap: 5px;
                cursor: pointer;
                width: calc(50% - 20px);
                

                &:hover{
                    background-color: rgba(232, 86, 70, .08);
                }

                .delete-icon{
                    font-size: 1.2rem;
                }

            }
        }
            }
        }

        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
`

const YukBulShareMessagesModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const { lockScroll, unlockScroll } = useScrollLock();

    const [selectedPhoneNumbers, setSelectedPhoneNumbers] = useState([])
    const [currentPhoneNumber, setCurrentPhoneNumber] = useState("")
    const [notificationText, setNotificationText] = useState("")

    const {modalLocation } = useSelector(state => state.modal)


    const {phoneNumbersForNotification} = useSelector(state => state.admin4)
    const { isLoadingShareYukBulItems, yukBulSelectedMessages } = useSelector(state => state.admin5)


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

        useEffect(()=> {
            if(currentPhoneNumber?.length >= 4){
                dispatch(getPhoneNumberForNotification(currentPhoneNumber))
            }
        },[currentPhoneNumber?.length])

    const handleSubmit = () => {

        if(selectedPhoneNumbers.length > 0){

            const body = {
                messageIds: yukBulSelectedMessages.map(item => item.id),
                userIds: selectedPhoneNumbers.map(item => item.userId),
                message: notificationText
            }
            
            dispatch(shareYukBulItems(body))
        }

    }

 
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <div className="input-container">
                <InputSelectForNotification phoneNumberList={selectedPhoneNumbers} setPhoneNumberList={(list) => setSelectedPhoneNumbers(list)} data={currentPhoneNumber} setData={setCurrentPhoneNumber} initialOptions={phoneNumbersForNotification} labelText={"Telefon Numarası"} name={"phoneNumbersForNotifications"} inputWidth={"350px"} />
                <InputTextarea data={notificationText} setData={(e) =>setNotificationText(e.target.value)} inputWidth={"320px"} labelText="Bildirim Metni" name={"notificationText"}/>

                </div>
                <div className="desc">Seçilen {yukBulSelectedMessages.length} mesaj, seçeceğiniz üyelere bildirim olarak gönderilecektir.</div>
  {
                    selectedPhoneNumbers.length > 0 &&
                    <div className="phone-number-list">
                        {
                            selectedPhoneNumbers.map((item) => (
                                <div className="phone-number-item" onClick={() => dispatch(setSelectedPhoneNumbers(selectedPhoneNumbers.filter(innerItem => innerItem.phoneNumber !== item.phoneNumber )))}>
                                    <IoCloseCircleOutline className="delete-icon"/>
                                    <div className="phone-number">{item.phoneNumber} - {item.username}</div>
                                </div>
                            ))
                        }
                    </div>
                }
           </div>
            <div className='button-grp'>
                <Btn bgColor="#E85446" color="#fff" handleClick={handleSubmit} width={"220px"}>{isLoadingShareYukBulItems ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Onayla ve Gönder"}</Btn>
                <Btn color="#E85446" bgColor="transparent" width={"220px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default YukBulShareMessagesModal